// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 744 ? "actioncable" : chunkId) + "-" + {"12":"9c1d9b6acfa4d5b1bff7","344":"94a463049d9c5cb1282c","744":"8b387cb23a4d51b4a473"}[chunkId] + ".chunk.js";
};